export const HighlightSectionHeader = ({
  title,
  subtitle,
  isLoading,
}: {
  title: string;
  subtitle?: string;
  isLoading: boolean;
}) => (
  <>
    <h2 className='text-primary text-headline-l md:text-headline-xl px-4 mb-8 md:mb-10'>{title}</h2>
    {subtitle &&
      (isLoading ? (
        <div className='h-5.5 md:h-7 bg-tertiary w-32 rounded-sm px-4 mb-6 md:mb-8 mx-4 animate-pulse'></div>
      ) : (
        <p className='text-headline-s px-4 md:text-headline-m mb-6 md:mb-8 text-tertiary'>{subtitle}</p>
      ))}
  </>
);
